<template>
  
  <div class="rating-total">
    
      <div class="total">
        <div class="icon" :class="settingsTotal.range.value>0?'bg-point':''">
          <img :src="require(`@/assets/image/rateLev_${settingsTotal.range.value}.svg`)" >
        </div>
        <p><strong>{{settingsTotal.avg}}</strong> / {{max.toPrecision(2)}}</p>
      </div>
    
      <p>"{{lang[settingsTotal.range.lang]}}"</p>
      
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'RatingTotal',
  props: ['lang', 'max', 'lists'],
  computed: {
    ...mapGetters(['getRange']),
    
    settingsTotal(){
      
      let total = 0, count=0, avg = 0;
      this.lists.forEach(x=>{
        if(x.value>0){
          total+=x.value;
          ++count;
        }
      });
      avg = (total/count).toPrecision(2);
      const value = total===0 ? 0 : Math.floor(avg)<1?1:Math.floor(avg);
      return {
        avg: total===0 ? (0).toPrecision(2):avg < 1 ? (1).toPrecision(2) : avg,
        range: this.getRange.filter(x=>{return x.value === value})[0]
      }
    },

  }
}
</script>

<style lang="scss" scoped>

.rating-total{
  @include flexs($col: center, $direction: column);
  
  .total{
    @include flexs-align(center, unset);

    .icon{
      width: 3.2rem;
      height: 3.2rem;
      background-color: $color-lightgray;
      border-radius: 100%;
      margin-right: 16px;
      position: relative;

     
      img{
        width: 88%;
        @include transform();
        
      }
       &.bg-point{
        background-color: $color-point;

        img{
          width: 64%;
          filter: brightness(0) invert(1)
        }
      }
      
    }  

    >p{
      strong{
        font-size: 180%;
        color: $color-point;
      }
    }

  }

  >p{
    text-align: center;
    margin-top: 16px;
  }
  
}


</style>